import { CheckCircle2, Server, Lock, Clock } from 'lucide-react';

export const FLIP_WORDS = {
    en: ['Core Banking', 'ATM Networks', 'POS Systems', 'Card Management'],
    ar: ['الأنظمة البنكية', 'شبكات الصراف', 'نقاط البيع', 'إدارة البطاقات']
};

export const STATS = [
    {
        value: 99,
        suffix: '.9%',
        labelEn: 'Uptime SLA',
        labelAr: 'تعهد بالاستقرار',
        icon: CheckCircle2,
        color: 'text-green-500'
    },
    {
        value: 0,
        suffix: 'ISO 8583',
        labelEn: 'Protocol',
        labelAr: 'البروتوكول العالمي',
        icon: Server,
        color: 'text-blue-500',
        isText: true
    },
    {
        value: 0,
        suffix: 'PCI-DSS',
        labelEn: 'Compliance',
        labelAr: 'الامتثال الأمني',
        icon: Lock,
        color: 'text-primary',
        isText: true
    },
    {
        value: 24,
        suffix: '/7',
        labelEn: 'Support',
        labelAr: 'دعم فني',
        icon: Clock,
        color: 'text-purple-500'
    },
];
